<div class="d-flex flex-row body-mod">
  <div class="d-flex flex-column justify-content-between">
    <div class="bwInfos">
      <div class="d-flex flex-row">
        <table class="table table-borderless">
          <thead>
            <tr>
              <th>
                <img class="bwImage" src="assets/icons/probesFamilies/black&White.png">
              </th>
              @if (!attestation) {
              <th class="type">
                @if (objetCourant?.bwInfo && objetCourant?.bwInfo?.bwCompromiseType) {
                <img class="notype"
                  src="assets/icons/ComprReport/{{formatType(objetCourant?.bwInfo?.bwCompromiseType)}}.svg">
                } @else {
                <h5 class="notype"> ?{{attestation}} </h5>
                }
              </th>
              }
            </tr>
          </thead>
          <tbody>
            @if (!attestation) {
            <tr>
              <th scope="row">{{'report-modal-bw-type' | translate}}</th>
              <td class="value">{{objetCourant?.bwInfo?.bwCompromiseType}}</td>
            </tr>
            }
            <tr>
              <th scope="row">{{'report-modal-bw-policy-version' | translate}}</th>
              @if (getlength(objetCourant?.bwInfo?.bwPolicyVersion)>25) {
              <td class="value"><span type="button" placement="right"
                  [ngbTooltip]="objetCourant?.bwInfo?.bwPolicyVersion">{{formatLongString(objetCourant?.bwInfo?.bwPolicyVersion)}}</span>
              </td>
              } @else {
              <td>{{objetCourant?.bwInfo?.bwPolicyVersion}}</td>
              }
            </tr>
            <tr>
              <th scope="row">{{'report-modal-bw-sdk' | translate}}</th>
              <td class="value">
                <span type="button" placement="right"
                  [ngbTooltip]="objetCourant?.bwInfo?.bwSdkVersion">{{formatLongString(objetCourant?.bwInfo?.bwSdkVersion)}}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="appInfos d-flex flex-row justify-content-between align-items-center">
      <div class="d-flex flex-column flex-grow-1 mb-2">
        <div class="d-flex flex-row align-items-center justify-content-between">
          <h4 class="mb-0">
            {{ objetCourant?.appInfo?.appName || objetCourant?.appInfo?.appId }}
          </h4>
          @if (objetCourant?.appInfo?.appName) {
          <button class="btn btn-outline-primary ms-3" (click)="getApp()">
            {{ 'report-modal-button-all' | translate }} {{ objetCourant?.appInfo?.appName }}
          </button>
          }
        </div>
        <table class="table table-borderless table-responsive infosapp mb-0">
          <thead>
            <tr>
              <th>{{ 'Version' }}</th>
              <th>{{ 'modal-installation-date' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                {{ objetCourant?.appInfo?.appVersion || ('unknown-app-version' | translate) }}
              </td>
              <td class="value d-flex flex-row align-items-center justify-content-center">
                @if (objetCourant?.appInfo?.appInstallationTimestamp) {
                <img class="installed me-2" src="assets/icons/ModalReports/installed.svg" alt="Install the">
                {{ getApptimeStamp() }}
                } @else {
                {{ 'unknown-app-installation-date' | translate }}
                }
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    @if (getMetaData()) {
    <div class="metadataInfos d-flex flex-row align-items-center justify-content-center">
      <h3>{{'attestations-title-metadata' | translate}}</h3>
      <button type="button" class="btn btn-outline-success" (click)="emitMetadata()">{{'see' | translate}}</button>
    </div>
    }
    <div class="locationInfos d-flex flex-row justify-content-center">
      <img src="assets/icons/location.svg">
      <h5>{{getContrycode()}} <span class="dot"></span> {{getCity()}} <span class="dot"></span>
        {{objetCourant?.location?.region}} </h5>
    </div>

  </div>
  <div class="deviceInfos d-flex flex-column {{objetCourant?.deviceInfo?.platformName?.toLowerCase()}}-infos">
    @if (objetCourant?.deviceInfo?.platformName?.toLowerCase()=='ios' ||
    objetCourant?.deviceInfo?.platformName?.toLowerCase()=='ipados') {
    <div class="d-flex flex-row justify-content-between headios">
      <div class="marque d-flex flex-row ">
        <img src="assets/icons/ModalReports/manufacters/apple.svg">
        <h2>{{formatName(objetCourant?.deviceInfo?.model)}}</h2>
      </div>
      <div class="osinfos d-flex flex-row">
        <img class="os{{objetCourant?.deviceInfo?.platformName?.toLowerCase()}}"
          src="assets/icons/logosOS/{{objetCourant?.deviceInfo?.platformName?.toLowerCase()}}.svg">
        <h2>v.{{formatVersion(objetCourant?.deviceInfo?.apiLevel)}}</h2>
      </div>
    </div>
    <table class="table table-borderless table-responsive">
      <tbody>
        <tr>
          <th scope="row">{{'report-modal-device-id' | translate}}</th>
          @if (getlength(objetCourant?.deviceId)>=20) {
          <td class="value"><span type="button" placement="right"
              [ngbTooltip]="objetCourant?.deviceId">{{formatLongString(objetCourant?.deviceId)}}</span></td>
          } @else {
          <td class="value">{{objetCourant?.deviceId}}</td>
          }
        </tr>
        <tr>
          <th scope="row">{{'report-modal-device-industrial-name' | translate}}</th>
          <td class="value">{{formatLongString(objetCourant?.deviceInfo?.industrialDeviceName)}}</td>
        </tr>
        <tr>
          <th scope="row">{{'report-modal-device-api-lvl' | translate}}</th>
          <td class="value">{{formatLongString(objetCourant?.deviceInfo?.apiLevel)}}</td>
        </tr>
        <tr>
          <th scope="row">{{'report-modal-device-kernel-version' | translate}}</th>
          <td class="value">
            <span type="button" placement="right"
              [ngbTooltip]="formatLongString(objetCourant?.deviceInfo?.kernelVersion)">{{formatKernelVersion()}}</span>
          </td>
        </tr>
        <tr>
          <th scope="row">{{'report-modal-device-architecture' | translate}}</th>
          <td class="value">{{objetCourant?.deviceInfo?.architecture}}</td>
        </tr>
      </tbody>
    </table>

    } @else {
    @if (objetCourant?.deviceInfo?.platformName?.toLowerCase()=='android') {
    <div class="d-flex flex-row justify-content-between headandroid align-items-center justify-content-center">
      @if (modelMarque()!='Unknown model') {
      <div class="marque d-flex flex-row align-items-center">
        <img src="assets/icons/ModalReports/manufacters/{{modelMarque()}}.svg" alt="">
        <h2>{{formatName(objetCourant?.deviceInfo?.model)}}</h2>
      </div>
      } @else {
      <div class="marque d-flex flex-row align-items-center">
        <h2>{{formatName(objetCourant?.deviceInfo?.model)}}</h2>
      </div>
      }
      <div class="osinfos d-flex flex-row align-items-center justify-content-center">
        <img src="assets/icons/logosOS/{{objetCourant?.deviceInfo?.platformName?.toLowerCase()}}.svg">
        <h2>v.{{formatVersion(objetCourant?.deviceInfo?.platformVersion)}}</h2>
      </div>
    </div>
    <table class="table table-borderless table-responsive">
      <tbody>
        <tr>
          <th scope="row">{{'report-modal-device-id' | translate}}</th>
          @if (getlength(objetCourant?.deviceId)>=20) {
          <td class="value"><span type="button" placement="right"
              [ngbTooltip]="objetCourant?.deviceId">{{formatLongString(objetCourant?.deviceId)}}</span></td>
          } @else {
          <td class="value">{{objetCourant?.deviceId}}</td>
          }
        </tr>
        <tr>
          <th scope="row">{{'report-modal-device-industrial-name' | translate}}</th>
          <td class="value">{{objetCourant?.deviceInfo?.industrialDeviceName}}</td>
        </tr>
        <tr>
          <th scope="row">{{'report-modal-device-fingerprint' | translate}}</th>
          <td class="value fingerprint">
            <span type="button" placement="right"
              [ngbTooltip]="objetCourant?.deviceInfo?.fingerprint">{{formatLongString(objetCourant?.deviceInfo?.fingerprint)}}</span>
          </td>
        </tr>
        <tr>
          <th scope="row">{{'report-modal-device-security-patch-level' | translate}}</th>
          <td class="value">{{objetCourant?.deviceInfo?.securityPatchLevel}}</td>
        </tr>
        @if (objetCourant?.deviceInfo?.board) {
        <tr>
          <th scope="row">{{'report-modal-device-board' | translate}}</th>
          <td class="value">{{objetCourant?.deviceInfo?.board}}</td>
        </tr>
        }
        <tr>
          <th scope="row">{{'report-modal-device-model' | translate}}</th>
          <td class="value text-capitalize">{{objetCourant?.deviceInfo?.model}}</td>
        </tr>
        <tr>
          <th scope="row">{{'report-modal-device-boot-loader' | translate}}</th>
          <td class="value text-capitalize">{{objetCourant?.deviceInfo?.bootloader}}</td>
        </tr>
        <tr>
          <th scope="row">{{'report-modal-device-api-lvl' | translate}}</th>
          <td class="value">{{objetCourant?.deviceInfo?.apiLevel}}</td>
        </tr>
        <tr>
          <th scope="row">{{'report-modal-device-kernel-version' | translate}}</th>
          <td class="value">
            <span type="button" placement="right"
              [ngbTooltip]="objetCourant?.deviceInfo?.kernelVersion">{{formatKernelVersion()}}</span>
          </td>
        </tr>
        <tr>
          <th scope="row">{{'report-modal-device-architecture' | translate}}</th>
          <td class="value">{{objetCourant?.deviceInfo?.architecture}}</td>
        </tr>
        <tr>
          <th scope="row">{{'report-modal-device-rom-model' | translate}}</th>
          <td class="value">{{objetCourant?.deviceInfo?.romName}}</td>
        </tr>
      </tbody>
    </table>
    }
    }
  </div>
</div>